var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContainerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1rem",
    height: "1rem",
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#27AE60"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1 11.4V14.9H22.6V11.4H19.1ZM18.4 10C18.0134 10 17.7 10.3134 17.7 10.7V15.6C17.7 15.9866 18.0134 16.3 18.4 16.3H23.3C23.6866 16.3 24 15.9866 24 15.6V10.7C24 10.3134 23.6866 10 23.3 10H18.4ZM11.4 19.1V22.6H14.9V19.1H11.4ZM10.7 17.7C10.3134 17.7 10 18.0134 10 18.4V23.3C10 23.6866 10.3134 24 10.7 24H15.6C15.9866 24 16.3 23.6866 16.3 23.3V18.4C16.3 18.0134 15.9866 17.7 15.6 17.7H10.7ZM19.1 22.6V19.1H22.6V22.6H19.1ZM17.7 18.4C17.7 18.0134 18.0134 17.7 18.4 17.7H23.3C23.6866 17.7 24 18.0134 24 18.4V23.3C24 23.6866 23.6866 24 23.3 24H18.4C18.0134 24 17.7 23.6866 17.7 23.3V18.4Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainerIcon);
export default __webpack_public_path__ + "static/media/container-icon.b91cedbc45e4a6d68fc81f6d64811da9.svg";
export { ForwardRef as ReactComponent };